import { Button, ModalV3, useTranslation } from '@helios/frontend-core';


interface OnboardingTimeoutModalProps {
  isOpen: boolean;
  onDismiss: () => void;
}

const TRACKING_ID = 'onboarding-timeout-modal';

export const OnboardingTimeoutModal = ({ isOpen, onDismiss }: OnboardingTimeoutModalProps) => {
  const { t } = useTranslation();

  const cta = (
    <div className="px-4">
      <Button onClick={onDismiss} trackingId={`${TRACKING_ID}-cta`}>
        {t('projectDetail.onboardingTimeoutModal.cta')}
      </Button>
    </div>
  );

  return (
    <ModalV3
      open={isOpen}
      onClose={onDismiss}
      trackingId={TRACKING_ID}
      bottomSheetProps={{ showCloseButton: false }}
      cta={cta}
    >
      <div className="flex flex-col items-center gap-12 text-text-primary px-4">
        <h2 className="label-900 text-center">{t('projectDetail.onboardingTimeoutModal.heading')}</h2>
        <p className="body-500">{t('projectDetail.onboardingTimeoutModal.body')}</p>
      </div>
    </ModalV3>
  );
};
